function MobileGreeting() 
{
    return (
        <div className="mobileGreeting">
            <p>Resume & Software Engineering Portfolio</p>
        </div>
    );
}

export default MobileGreeting;